import { createRouter, createWebHistory } from "vue-router";
import api from "@/services/api";
import DashboardView from "@/views/dashboard/DashboardView.vue";
import MonitoringView from "@/views/monitoringdoct/MonitoringView.vue";
import DocumentFormView from "@/views/monitoringdoct/DocumentFormView.vue";
import TransportOffers from "@/views/transportOffers/TransportOffersView.vue";
import TransportOffersForm from "@/views/transportOffers/TransportOffersForm.vue";
import AssetView from "@/views/assetIT/asset/AssetView.vue";
import AssetFormView from "@/views/assetIT/asset/AssetFormView.vue";
import KeteranganView from "@/views/master/keterangan/KeteranganView.vue";
import CoaView from "@/views/master/coa/CoaView.vue";
import InfrasView from "@/views/assetIT/InfrasIT/InfrasView.vue";
import InfrasFormView from "@/views/assetIT/InfrasIT/InfrasFormView.vue";
import SpecificationView from "@/views/master/specification/SpecificationView.vue";
import DeviceTypeView from "@/views/master/devicetype/DeviceTypeView.vue";
import PartnerTypeView from "@/views/master/partnerType/PartnerTypeView.vue";
import PksView from "@/views/transportOffers/PksView.vue";
import DeviceSpecificationView from "@/views/master/deviceSpecification/DeviceSpecificationView.vue";
import EvaluationApprovalView from "@/views/evaluation/EvaluationApprovalView.vue";
import VendorEvaluationForm from "@/views/evaluation/VendorEvaluationForm.vue";
import ReportOverdueView from "@/views/report/ReportOverdueView.vue";
import ReportApprovedSupplierView from "@/views/report/ReportApprovedSupplierView.vue";
import ReportSphSpkView from "@/views/report/ReportSphSpkView.vue";
import ReportAssetNumberView from "@/views/report/ReportAssetNumberView.vue";
import ReportContractStatusView from "@/views/report/ReportContractStatusView.vue";
import ReportExpiringView from "@/views/report/ReportExpiringView.vue";
import ReportOverdueSPHView from "@/views/report/ReportOverdueSPHView.vue";
import ReportOpnameLicenseView from "@/views/report/ReportOpnameLicenseView.vue";
import ReportInventarisAssetView from "@/views/report/ReportInventarisAssetView.vue";
import ReportAssetWithNumberView from "@/views/report/ReportAssetWithNumberView.vue";
import LoginView from "@/views/auth/LoginView.vue";
import {
  isAuthenticated,
  goToLogin,
  decodeJwt,
  saveSession,
  consumePostLoginRedirect,
  clearSession,
  setTokenCookie,
  getTokenJwt,
  getUserLogin,
} from "@/utils/auth";

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { public: true },
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next(consumePostLoginRedirect());
        return;
      }

      next();
    },
  },
  { path: "/", redirect: "/dashboard" },
  { path: "/dashboard", name: "dashboard", component: DashboardView },

  //Monitoring Dokumen perjanjian Kerjasama
  {
    path: "/monitoring-document",
    name: "monitoring",
    component: MonitoringView,
  },
  {
    path: "/detail-document/:id",
    name: "detaildocument",
    component: DocumentFormView,
    props: { mode: "detail" },
  },
  {
    path: "/add-document",
    name: "adddocument",
    component: DocumentFormView,
    props: { mode: "add" },
  },
  {
    path: "/edit-document/:id",
    name: "editdocument",
    component: DocumentFormView,
    props: { mode: "edit" },
  },
  {
    path: "/vendor-evaluation/:id?",
    name: "VendorEvaluationForm",
    component: VendorEvaluationForm,
  },
  {
    path: "/evaluation/evaluation-approval",
    name: "EvaluationApprovalView",
    component: EvaluationApprovalView,
  },

  //PENAWARAN HARGA
  {
    path: "/transport/transport-offers",
    name: "transportoffers",
    component: TransportOffers,
  },
  {
    path: "/transport/transport-offers/add",

    name: "transportoffersadd",

    component: TransportOffersForm,

    props: {
      mode: "add",
    },
  },
  {
    path: "/transport/transport-offers/edit/:id",

    name: "transportoffersedit",

    component: TransportOffersForm,

    props: (route) => ({
      mode: "edit",

      id: route.params.id,
    }),
  },

  {
    path: "/transport/transport-offers/detail/:id",

    name: "transportoffersdetail",

    component: TransportOffersForm,

    props: (route) => ({
      mode: "detail",

      id: route.params.id,
    }),
  },

  {
    path: "/transport/transport-offers-pks",
    name: "transportofferspks",
    component: PksView,
  },

  //ASSET
  // ASSET - LAPTOP/PC
  {
    path: "/asset/asset-it",
    name: "assetIt",
    component: AssetView,
  },
  {
    path: "/asset/asset-it/detail/:id",
    name: "detailAsset",
    component: AssetFormView,
    props: { mode: "detail" },
  },
  {
    path: "/asset/asset-it/add",
    name: "addAsset",
    component: AssetFormView,
    props: { mode: "add" },
  },
  {
    path: "/asset/asset-it/edit/:id",
    name: "editAsset",
    component: AssetFormView,
    props: { mode: "edit" },
  },

  // ASSET - INFRASTRUKTUR IT
  {
    path: "/asset/infrastructure-it",
    name: "infrastructureIt",
    component: InfrasView,
  },
  {
    path: "/asset/infrastructure-it/add",
    name: "addInfrastructure",
    component: InfrasFormView,
    props: { mode: "add" },
  },
  {
    path: "/asset/infrastructure-it/edit/:id",
    name: "editInfrastructure",
    component: InfrasFormView,
    props: { mode: "edit" },
  },
  {
    path: "/asset/infrastructure-it/detail/:id",
    name: "detailInfrastructure",
    component: InfrasFormView,
    props: { mode: "detail" },
  },

  //MASTER
  {
    path: "/master/partner-type",
    name: "partner-type",
    component: PartnerTypeView,
  },

  {
    path: "/master/keterangan",
    name: "keterangan",
    component: KeteranganView,
  },
  {
    path: "/master/coa",
    name: "coa",
    component: CoaView,
  },
  {
    path: "/master/specification",
    name: "specification",
    component: SpecificationView,
  },
  {
    path: "/master/device-type",
    name: "device-type",
    component: DeviceTypeView,
  },
  {
    path: "/master/device-specification",
    name: "device-specification",
    component: DeviceSpecificationView,
  },

  {
    path: "/report/report-overdue",
    name: "report-overdue",
    component: ReportOverdueView,
  },
  {
    path: "/report/monitoring-sph-spk",
    name: "monitoring-sph-spk",
    component: ReportSphSpkView,
  },
  {
    path: "/report/approved-supplier",
    name: "approved-supplier",
    component: ReportApprovedSupplierView,
  },
  {
    path: "/report/report-asset-number",
    name: "report-asset-number",
    component: ReportAssetNumberView,
  },
  {
    path: "/report/report-contract-status",
    name: "report-contract-status",
    component: ReportContractStatusView,
  },
  {
    path: "/report/report-expiring",
    name: "report-expiring",
    component: ReportExpiringView,
  },
  {
    path: "/report/report-overdue-sph",
    name: "report-overdue-sph",
    component: ReportOverdueSPHView,
  },
  {
    path: "/report/opname-license",
    name: "opname-license",
    component: ReportOpnameLicenseView,
  },
  {
    path: "/report/inventaris-asset",
    name: "inventaris-asset",
    component: ReportInventarisAssetView,
  },
  {
    path: "/report/asset-with-number",
    name: "asset-with-number",
    component: ReportAssetWithNumberView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const hasTokenParam = Object.prototype.hasOwnProperty.call(
    to.query,
    "token_jwt",
  );
  const tokenJwt = to.query.token_jwt;

  if (hasTokenParam) {
    // Datang dari SSO tapi token kosong -> jangan diam-diam pakai sesi lama
    if (!tokenJwt) {
      clearSession();
      console.error(
        "SSO tidak mengirim token_jwt (kosong). Cek cookie token_jwt di server SSO.",
      );
      goToLogin(to.path);
      return false;
    }

    const decoded = decodeJwt(tokenJwt);

    if (!decoded) {
      clearSession();
      console.error("Token dari SSO tidak valid / gagal di-decode:", tokenJwt);
      goToLogin(to.path);
      return false;
    }

    clearSession();

    setTokenCookie(tokenJwt);

    // eslint-disable-next-line no-unused-vars
    const { mst_employee_photo: _staleJwtPhoto, ...decodedWithoutPhoto } =
      decoded;

    let fullProfile = decodedWithoutPhoto;
    try {
      const res = await api.get(`/employee/${decoded.mst_employee_id}`);
      fullProfile = { ...decodedWithoutPhoto, ...res.data.data };
    } catch (e) {
      console.error(
        "Gagal ambil profil lengkap, foto akan pakai ikon default:",
        e,
      );
    }

    saveSession(tokenJwt, fullProfile);

    const target = to.path === "/login" ? consumePostLoginRedirect() : to.path;
    window.location.replace(target);
    return;
  }

  if (to.meta.public) return true;

  if (!isAuthenticated()) {
    goToLogin(to.fullPath);
    return false;
  }

  const token = getTokenJwt();
  const payload = token ? decodeJwt(token) : null;
  const cached = getUserLogin();
  if (
    payload?.mst_employee_id &&
    cached?.mst_employee_id &&
    Number(payload.mst_employee_id) !== Number(cached.mst_employee_id)
  ) {
    console.warn(
      "Sesi tidak konsisten (JWT vs userLogin). Membersihkan dan minta login ulang.",
    );
    clearSession();
    goToLogin(to.fullPath);
    return false;
  }

  return true;
});

export default router;
